import { Component,  Input } from '@angular/core';
import { ViewProfileDialogComponent } from 'src/app/modules/workforce/workforce.dialog.viewProfile.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { WorkerWithProfile } from 'globals/store/workforce.data';
import { PersonCardComponent } from './person-card.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'worker-card',
    template: `
  <person-card *ngIf="!!worker" (select)="openWorker()" [hidePhoto]="hidePhoto" [size]="size"
          [cardTitle]="worker.firstName + ' ' + worker.lastName + titleAddedText" 
          [disableSelect]="disableSelect"
          [photoUrl]="worker.photoURL"></person-card>
`,
    standalone: true,
    imports: [MatDialogModule, CommonModule, PersonCardComponent],
})

export class WorkerCardComponent {
  @Input() worker: WorkerWithProfile
  @Input() hidePhoto = false
  @Input() size = 24
  @Input() titleAddedText = ''
  @Input() disableSelect = false
  @Input() disableOpenWorker = false
  constructor(
    public dialog: MatDialog,
  ) {

  }
  
  
  openWorker() {
    if (this.disableOpenWorker) return
    this.dialog.open(ViewProfileDialogComponent, { width: '480px', data: { 
      worker: this.worker, 
      profileProvided: true
    }})
  }
}
